import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quickform-discount" }
const _hoisted_2 = ["aria-expanded"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSvg = _resolveComponent("BaseSvg")!
  const _component_TripDiscount = _resolveComponent("TripDiscount")!
  const _component_BaseExpansion = _resolveComponent("BaseExpansion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "quickform-discount__toggle",
      "aria-expanded": _ctx.expanded,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _cache[1] || (_cache[1] = _createTextVNode(" Promotional Code ")),
      _createVNode(_component_BaseSvg, { icon: "chevron/chevron-dropdown-down" })
    ], 8, _hoisted_2),
    _createVNode(_component_BaseExpansion, { expanded: _ctx.expanded }, {
      default: _withCtx(() => [
        _createVNode(_component_TripDiscount, {
          class: "quickform-discount__form",
          applyVoucher: _ctx.applyVoucher
        }, null, 8, ["applyVoucher"])
      ]),
      _: 1
    }, 8, ["expanded"])
  ]))
}